<kendo-switch
  kendoTooltip
  [disabled]="disabled"
  [ngClass]="{ indeterminate: value === null }"
  size="small"
  [checked]="value === null || value === true"
  (valueChange)="toggle()"
></kendo-switch>
